import React from 'react';
import { CloseButton, Inner, Wrapper } from './styles';
import CloseIcon from 'mdi-react/CloseIcon';

export interface AnimatedModalProps {
  in?: boolean;
  onExited?: () => void;
}

interface ModalProps {
  children: React.ReactNode;
  title: string;
  open?: boolean;
  onHide?: () => void;
}

const Modal = ({ title, open = false, onHide, children }: ModalProps) => {
  return (
    <Wrapper
      onMouseDown={onHide}
      style={{
        opacity: open ? 1 : 0,
        pointerEvents: open ? 'auto' : 'none',
      }}
    >
      <div style={{ opacity: open ? 1 : 0 }}>
        <div onMouseDown={(e) => e.stopPropagation()}>
          <Inner>
            <CloseButton onClick={onHide}>
              <CloseIcon />
            </CloseButton>
            <h3>{title}</h3>
            {children}
          </Inner>
        </div>
      </div>
    </Wrapper>
  );
};

export default Modal;
